var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.01151 10.6666C7.76399 10.6665 7.52664 10.573 7.35164 10.4067L3.61831 6.85838C3.52917 6.77656 3.45806 6.67867 3.40915 6.57045C3.36023 6.46222 3.33449 6.34582 3.33341 6.22803C3.33233 6.11025 3.35595 5.99344 3.40288 5.88442C3.4498 5.7754 3.51911 5.67636 3.60674 5.59307C3.69437 5.50978 3.79858 5.44391 3.91329 5.39931C4.02799 5.35471 4.15089 5.33226 4.27482 5.33329C4.39874 5.33431 4.52122 5.35878 4.63509 5.40527C4.74896 5.45176 4.85195 5.51934 4.93804 5.60407L8.01151 8.52519L11.085 5.60407C11.261 5.44248 11.4968 5.35307 11.7415 5.35509C11.9862 5.35711 12.2203 5.4504 12.3933 5.61487C12.5664 5.77934 12.6645 6.00183 12.6667 6.23442C12.6688 6.46701 12.5747 6.69108 12.4047 6.85838L8.67138 10.4067C8.49638 10.573 8.25902 10.6665 8.01151 10.6666Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownOutline);
export default __webpack_public_path__ + "static/media/chevron-down-outline.5da2aa2a622df58508d65e37028b5a6a.svg";
export { ForwardRef as ReactComponent };